import React, { FC } from 'react';
import CustomSelect from '../../../common/CustomSelect';
import { getOptionsFromTranslation } from '../../../utils/utils';
import Text from '@ingka/text';
import useTranslation from '../../../hooks/useTranslation';

type Props = {
  onProgrammeChange?: (value: string) => void;
};

const ProjectProgrammeNameSelect: FC<Props> = ({ onProgrammeChange }) => {
  const t = useTranslation();

  const handleChange = (e: any) => {
    onProgrammeChange?.(e.target.value);
  };

  return (
    <>
      <Text textStyle="Heading.S" tagName="h4">
        {t('labels.partOfApprovedProgramme')}
      </Text>
      <CustomSelect
        optionsArray={{
          ...getOptionsFromTranslation(t, 'programmes'),
        }}
        name={'programmeName'}
        dataTestID={'programme-select'}
        label={t('tooltips.programmeName')}
        customOnChange={handleChange}
      />
    </>
  );
};

export default ProjectProgrammeNameSelect;
